import { render, staticRenderFns } from "./PatientSmall.vue?vue&type=template&id=460f0f8d&scoped=true&"
import script from "./PatientSmall.vue?vue&type=script&lang=js&"
export * from "./PatientSmall.vue?vue&type=script&lang=js&"
import style0 from "./PatientSmall.vue?vue&type=style&index=0&id=460f0f8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f0f8d",
  null
  
)

export default component.exports